import { useField } from 'formik';
import { useMemo } from 'react';
import GenericDatePicker from '../GenericDatePicker';

const DatePicker = ({
    label,
    onChange,
    css,
    ...props
}) => {
    const [field, meta, { setValue, setTouched }] = useField(props);

    const error = useMemo(() => {
        if (meta.touched && meta.error) {
            return <div className='text-danger small'>{meta.error}</div>;
        }

        return null;
    }, [meta]);

    return (
        <div className={`${css}`}>
            <GenericDatePicker
                initialValue={field.value}
                label={label}
                onChange={(newDate) => {
                    setTouched(true);
                    setValue(newDate);
                    if (onChange) {
                        onChange(newDate);
                    }
                }}
                css={{
                    input: meta.touched && meta.error ? 'border-danger' : '',
                }}
                {...props}
            />
            {error}
        </div>
    );
};

export default DatePicker;